"use client";

import { useEffect } from "react";
import posthog from "posthog-js";

type GlobalErrorProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function GlobalError({ error, reset }: GlobalErrorProps) {
  useEffect(() => {
    const environment = process.env.NODE_ENV === "production" ? "prod" : "dev";

    try {
      posthog.captureException(error, {
        environment,
        stack: "nextjs",
        source: "global-error-boundary",
        digest: error.digest ?? null,
      });
    } catch {
      // Never throw from error instrumentation
    }
  }, [error]);

  return (
    <html>
      <body>
        <h2>Something went wrong.</h2>
        <button onClick={() => reset()}>Try again</button>
      </body>
    </html>
  );
}
